import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

// src/plugins/vuetify.js
export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#6200EA", // Deep Purple
        secondary: "#2D3748",
        accent: "#FFB74D",
        background: "#F4F6F8", // Light Grey-Blue (Not pure white)
        surface: "#FFFFFF", // Pure White (For Cards)
        info: "#00B8D4",
        success: "#4CAF50",
      },
      dark: {
        primary: "#B388FF", // Light Lavender (Better contrast on dark)
        secondary: "#F5F5F5", // Off-White (For text - CRITICAL for readability)
        background: "#121212",
        surface: "#1E1E1E",
      },
    },
  },
});
